module.exports = __webpack_public_path__ + "static/media/buildingConstruction42.ff1beda1.jpg";